<template>
  <div>
    <div v-if="limsds_userDetails.userEmail != null && limsds_userDetails.userEmail != ''">
      <v-form>
        <v-row dense>
          <v-col sm="11" class="Instructions">Enter Sample Information </v-col>
          <v-col align="Right" sm="1">
            <v-menu open-on-hover top offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="orange" small v-bind="attrs" v-on="on"
                  >mdi-help</v-icon
                >
              </template>

              <v-list>
                <v-list-item
                  ><a
                    :href="NewsLetter"
                    title="Newsletter Index"
                    target="limsds_help"
                    >Newsletter Index</a
                  ></v-list-item
                >
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              solo
              hide-details
              dense
              label="Select Site"
              v-model="list.site1"
              @input="FillUnitDropDown"
              :items="defaultValues.SiteList"
              item-text="site"
              item-value="site"
            ></v-select>
          </v-col></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              label="Select Unit"
              v-model="list.SelectedUnit"
              @input="FillAreaDropDown"
              :items="defaultValues.UnitList"
              solo
              hide-details
              dense
              item-text="UnitName"
              item-value="UnitValue"
            ></v-select>
          </v-col></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              solo
              hide-details
              dense
              label="Select Area"
              v-model="list.SelectedArea"
              :items="defaultValues.AreaList"
              item-text="value"
              item-value="key"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              solo
              hide-details
              dense
              label="Sample Point"
              v-model="defaultValues.SelectedSamplePoint"
              :items="defaultValues.SamplePointList"
              item-text="Name"
              item-value="Identity"
              @input="FillProductDropDown()"
            ></v-select>
          </v-col></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              solo
              hide-details
              dense
              label="Select Product"
              v-model="defaultValues.SelectedProduct"
              :items="defaultValues.ProductList"
              item-text="Name"
              item-value="Identity"
              @input="FillSamplePointDropDown()"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-text-field
              v-model="defaultValues.SampleDate"
              dense
              solo
              hide-details
              type="Date"
              label="Sample Date"
            ></v-text-field>
          </v-col></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-text-field
              v-model="defaultValues.SampleTime"
              dense
              solo
              hide-details
              type="time"
              label="Sample Time"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-text-field
              v-model="defaultValues.BatchID"
              dense
              solo
              hide-details
              label="Batch ID"
            ></v-text-field>
          </v-col></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-text-field
              v-model="defaultValues.LotID"
              dense
              solo
              hide-details
              label="Lot ID"
            ></v-text-field>
          </v-col></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-text-field
              v-model="defaultValues.Description"
              dense
              solo
              hide-details
              label="Description"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              solo
              hide-details
              dense
              label="Select Workflow"
              v-model="defaultValues.SelectedWorkflow"
              :items="defaultValues.WorkflowList"
              item-text="Name"
              item-value="Identity"
            ></v-select>
          </v-col></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              solo
              hide-details
              dense
              label="Select Test Schedule"
              v-model="defaultValues.SelectedTestSchedule"
              :items="defaultValues.TestScheduleList"
              item-text="Name"
              item-value="Identity"
              @input="FillTestAnalysis()"
            ></v-select>
          </v-col>
          <v-col sm="2">
            <v-btn
              rounded
              color="primary"
              dark
              dense
              solo
              hide-details
              @click="FillTestScheduleDropDown()"
              >Get Test Schedule
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
            sm="12"
            md="4"
            lg="3"
            v-for="(user, i) in defaultValues.AnalysisList"
            :key="user.Identity"
          >
            <v-checkbox
              hide-details
              dense
              :label="user.Name"
              v-model="defaultValues.SelectedAnalysis[i]"
            ></v-checkbox> </v-col
        ></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-textarea
              v-model="defaultValues.Note"
              dense
              label="Note"
              auto-grow
              solo
              hide-details
              rows="2"
              row-height="15"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="3">
            <v-btn
              rounded
              color="primary"
              dark
              dense
              solo
              hide-details
              @click="LoginSample()"
              >Login Samples
            </v-btn>
          </v-col>
        </v-row>
        <br />
        <v-row dense v-show="Show">
          <v-col>
            <v-data-table
              dense
              v-model="SelectedSampleListResult"
              :headers="Resultheaders"
              :items="defaultValues.LoginSampleList"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 20],
              }"
              :items-per-page="list.Rowsinresulttable"
              item-key="IdNumeric"
              :loading="isLoading"
              loading-text="Loading... Please wait"
              show-select
              :hide-default-footer="true"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Logged Sample</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <br />
        <v-row dense v-show="Show">
          <v-col sm="4">
            <v-select
              solo
              hide-details
              dense
              label="Select Label Template"
              v-model="defaultValues.SelectedLabelTemp"
              :items="defaultValues.LabelTemplateList"
              item-text="Name"
              item-value="Identity"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense v-show="Show">
          <v-col sm="4">
            <v-select
              label="Printer"
              v-model="defaultValues.SelectedPrinter"
              :items="defaultValues.PrinterList"
              solo
              hide-details
              dense
              item-text="Name"
              item-value="Identity"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense v-show="Show">
          <v-col sm="4">
            <v-text-field
              v-model="defaultValues.Copies"
              dense
              solo
              hide-details
              type="Number"
              label="Copies"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense v-show="Show">
          <v-col sm="2">
            <v-btn
              rounded
              dense
              solo
              hide-details
              color="primary"
              dark
              @click="PrintLabel()"
              >Print Labels
            </v-btn>
          </v-col>
        </v-row>
        <br />
        <v-row dense v-show="ShowPrint">
          <v-col>
            <v-data-table
              dense
              :headers="PrintResultheaders"
              :items="defaultValues.PrintLabelResult"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 20],
              }"
              :items-per-page="list.Rowsinresulttable"
              item-key="Id"
              :loading="isLoading"
              loading-text="Loading... Please wait"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Print Sample</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td>
                    <div
                      :style="{ color: ' #00FF00' }"
                      v-if="item.IsError == false"
                    >
                      <b> Successful</b>
                    </div>
                    <div
                      :style="{ color: ' #f67e7e' }"
                      v-if="item.IsError == true"
                    >
                      <b> Failed </b>
                    </div>
                  </td>
                  <td>{{ item.Message }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div v-if="limsds_userDetails.userEmail == null">
      <h3>INVALID USER !!!</h3>
      <h4>Current user is not exist in system database !!!</h4>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import uiView from "@/_mixins/ui-view-mixin";
import appMixin from "../mixins/app-mixin";
import moment from "moment";
export default {
  name: "SubmitSample",
  mixins: [uiView, appMixin],
  components: {},

  created() {
    let that = this;
    this.NewsLetter = this.settings.NewsLetter;
    if (this.limsds_userDetails.userEmail != null) {
      this.list = this.limsds_userPreference;
      this.PrefSite = this.list.site1;
      this.DateFormat = this.list.Dateformat;
      this.fillSite();
      this.FillWorkFlow();
      this.FillUnitDropDown(this.list.site1);
      this.FillAreaDropDown(this.list.SelectedUnit);
      this.FillSamplePointDropDown(
        this.list.site1,
        this.list.SelectedUnit,
        this.list.SelectedArea,
        this.defaultValues.SelectedProduct
      );
      this.FillProductDropDown(
        this.list.site1,
        this.list.SelectedUnit,
        this.list.SelectedArea,
        this.defaultValues.SelectedSamplePoint
      );
      this.FillLabelPrinterDropDown();
    }
  },
  mounted() {},
  computed: {},
  watch: {},
  data() {
    return {
      Show: false,
      ShowPrint: false,
      DateFormat: null,
      singleSelect: false,
      isLoading: false,
      list: {},
      XmlSamplePoints: {},
      SampleListResult: [],
      SelectedSampleListResult: [],
      defaultValues: {
        Note: "",
        Copies: 1,
        SiteList: undefined,
        UnitList: undefined,
        AreaList: undefined,
        AnalysisList: [],
        LoginSampleList: [],
        SelectedWorkflow: undefined,
        SelectedAnalysis: [],
        PrintLabelResult: [],
        WorkflowList: [],
        SelectedTestSchedule: undefined,
        TestScheduleList: undefined,
        SamplePointList: [],
        ProductList: [],
        SelectedLabelTemp: "",
        SelectedPrinter: "",
        LabelTemplateList: [],
        PrinterList: [],
        onlySamplesPreviousYear: "1",
        lims_internal: "0",
        SelectedUnit: null,
        SelectedArea: null,
        SelectedSamplePoint: "all",
        SelectedProduct: "all",
        BatchID: "",
        LotID: "",
        Description: "",
        SampleDate: moment().format("YYYY-MM-DD"),
        SampleTime: moment().format("hh:mm:ss"),
      },
      PrintResultheaders: [
        { text: "Status" },
        { text: "Message", value: "Message" },
      ],
      Resultheaders: [
        { text: "Sample Number", value: "Id", align: "start", sortable: false },
        { text: "Sample ID", value: "IdText" },
        { text: "Sample Name", value: "SampleName" },
        { text: "Message", value: "Message" },
      ],
    };
  },

  methods: {
    fillSite() {
      let that = this;
      const SiteLink = this.settings.WASite + "UserID=" + this.limsds_userDetails.userEmail;
      axios.get(SiteLink).then((response) => {
        that.defaultValues.SiteList = response.data.enumSiteLists;
      });
    },
    PrintLabel(sampleIds = "") {
      this.ShowPrint = true;
      sampleIds += this.SelectedSampleListResult.map((e) => {
        return `${e.Id},`;
      }).join("");
      const Print =
        this.settings.WAPrint +
        "sampleIds=" +
        sampleIds +
        "&site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&labelTemplate=" +
        this.defaultValues.SelectedLabelTemp +
        "&printer=" +
        this.defaultValues.SelectedPrinter +
        "&numberOfPrintCopies=" +
        this.defaultValues.Copies;
      axios.get(Print).then((response) => {
        console.log(response.data);
        this.defaultValues.PrintLabelResult = JSON.parse(response.data);
      });
    },
    LoginSample() {
      var that = this;
      const LoginSample =
        this.settings.WALoginSample +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&area=" +
        this.list.SelectedArea +
        "&samplePoint=" +
        this.defaultValues.SelectedSamplePoint +
        "&product=" +
        this.defaultValues.SelectedProduct +
        "&sampledDate=" +
        this.defaultValues.SampleDate +
        "&lotNumber=" +
        this.defaultValues.LotID +
        "&batchNumber=" +
        this.defaultValues.BatchID +
        "&description=" +
        this.defaultValues.Description +
        "&notes=" +
        this.defaultValues.Note +
        "&testSchedule=" +
        this.defaultValues.SelectedTestSchedule +
        "&analyses=" +
        this.defaultValues.SelectedAnalysis +
        "&workflow=" +
        this.defaultValues.SelectedWorkflow;

      axios.get(LoginSample).then((response) => {
        console.log(response.data);
        this.defaultValues.LoginSampleList = JSON.parse(response.data);
      });
      this.Show = true;
    },
    FillWorkFlow() {
      const WorkFlowLink =
        this.settings.WAWorkFlow +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit;
      axios.get(WorkFlowLink).then((response) => {
        if (response.data != "") {
          this.defaultValues.WorkflowList = JSON.parse(response.data);
        } else {
          this.defaultValues.WorkflowList = [];
        }
      });
    },
    FillUnitDropDown(value) {
      const UnitLink =
        this.settings.WAUnit +
        "UserID=" +
        this.limsds_userDetails.userEmail +
        "&site=" +
        this.list.site1 +
        "&lims_internal=" +
        this.defaultValues.lims_internal +
        "&onlySamplesPreviousYear=" +
        this.defaultValues.onlySamplesPreviousYear;
      axios.get(UnitLink).then((response) => {
        this.defaultValues.UnitList = response.data.unitLists;
        this.FillWorkFlow();
      });
    },
    FillAreaDropDown(value) {
      let that= this;
      const AreaLink =
        this.settings.SMWAArea +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&preferredArea=" +
        "";
      axios.get(AreaLink).then((response) => {
        that.defaultValues.AreaList = response.data;
        that.FillWorkFlow();
      });
    },
    FillLabelPrinterDropDown() {
      const LabelTemplateLink =
        this.settings.WALabelTemplate +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit;
      axios.get(LabelTemplateLink).then((response) => {
        this.defaultValues.LabelTemplateList.push({
          Name: "Default Label Template",
          Identity: "",
        });
        this.defaultValues.LabelTemplateList.push(
          ...JSON.parse(response.data.value)
        );
      });

      const PrinterLink =
        this.settings.WAPrinter +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit;
      axios.get(PrinterLink).then((response) => {
        this.defaultValues.PrinterList.push({
          Name: "Default Printer",
          Identity: "",
        });
        this.defaultValues.PrinterList.push(...JSON.parse(response.data.value));
      });
    },
    FillSamplePointDropDown() {
      var that = this;
      if (
        this.list.SelectedUnit == null ||
        this.list.SelectedUnit == undefined ||
        this.list.SelectedUnit == ""
      ) {
        this.list.SelectedUnit = "all";
      }
      if (
        this.list.SelectedArea == null ||
        this.list.SelectedArea == undefined ||
        this.list.SelectedArea == ""
      ) {
        this.list.SelectedArea = "all";
      }
      const SamplePoints =
        this.settings.WASamplePoints +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&areaID=" +
        this.list.SelectedArea +
        "&product=" +
        this.defaultValues.SelectedProduct;
      axios.get(SamplePoints).then((response) => {
        var SamplepointTemp = [{ Name: "All Sample Point", Identity: "all" }];
        SamplepointTemp.push(...JSON.parse(response.data));
        that.$set(that.defaultValues, "SamplePointList", SamplepointTemp);
      });
    },
    FillProductDropDown() {
      var that = this;
      if (
        this.list.SelectedUnit == null ||
        this.list.SelectedUnit == undefined ||
        this.list.SelectedUnit == ""
      ) {
        this.list.SelectedUnit = "all";
      }
      if (
        this.list.SelectedArea == null ||
        this.list.SelectedArea == undefined ||
        this.list.SelectedArea == ""
      ) {
        this.list.SelectedArea = "all";
      }
      const Product =
        this.settings.WAProductList +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&areaID=" +
        this.list.SelectedArea +
        "&samplePointID=" +
        this.defaultValues.SelectedSamplePoint;

      axios.get(Product).then((response) => {
        var productTemp = [{ Name: "All Product", Identity: "all" }];
        productTemp.push(...JSON.parse(response.data));
        that.$set(that.defaultValues, "ProductList", productTemp);
      });
    },
    FillTestScheduleDropDown() {
      var that = this;
      const TestSchedule =
        this.settings.WATestSchedule +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&product=" +
        this.defaultValues.SelectedProduct +
        "&samplePoint=" +
        this.defaultValues.SelectedSamplePoint +
        "&workflowID=" +
        this.defaultValues.SelectedWorkflow;
      axios.get(TestSchedule).then((response) => {
        var TestScheduleTemp = [{ Name: "All Test Schedule", Identity: "all" }];
        TestScheduleTemp.push(...JSON.parse(response.data));
        that.$set(that.defaultValues, "TestScheduleList", TestScheduleTemp);
      });
    },
    FillTestAnalysis() {
      var that = this;
      const ListOfAnalysis =
        this.settings.WAListOfAnalysis +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.list.SelectedUnit +
        "&TestScheduleID=" +
        this.defaultValues.SelectedTestSchedule;

      axios.get(ListOfAnalysis).then((response) => {
        console.log(response.data);
        that.$set(
          that.defaultValues,
          "AnalysisList",
          JSON.parse(response.data)
        );
        that.defaultValues.SelectedAnalysis.push(
          ...JSON.parse(response.data).map((ex) => ex.Identity)
        );
      });
    },
  },
};
</script>
<style lang="scss">

.v-text-field.v-text-field--solo.v-input--dense > .v-input__control, .v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
    min-height: 24px;
}
.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label, .v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label {
    top: 3px;
}
.v-text-field__slot {
    padding: 0px !important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 26px;
  min-width: 64px;
  padding: 0 10px;
}
</style>